"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable */
const prop_types_1 = __importDefault(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
const pattern_library_components_icon_1 = require("@saatva-bits/pattern-library.components.icon");
const Swatch_module_scss_1 = __importDefault(require("./Swatch.module.scss"));
const inverseCheckIconColor = (swatch) => {
    var _a;
    if (!swatch) {
        return false;
    }
    // Add condition for swatches using background images that contain a #xxxxxx or rgb() color value
    let color = swatch.includes('url') ? (_a = swatch.match(/(rgb.+?\))|([#0-9A-Fa-f]{7})/)) === null || _a === void 0 ? void 0 : _a[0] : swatch;
    if (!color)
        return false;
    let r, g, b;
    // Check the format of the color, HEX or RGB?
    if (color.match(/^rgb/)) {
        // If HEX --> store the red, green, blue values in separate variables
        color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
        r = color[1];
        g = color[2];
        b = color[3];
    }
    else {
        // If RGB --> Convert it to HEX: http://gist.github.com/983661
        color = +('0x' + color.slice(1).replace(color.length < 5 && /./g, '$&$&'));
        r = color >> 16;
        g = color >> 8 & 255;
        b = color & 255;
    }
    // HSP equation
    const hsp = Math.sqrt(0.299 * (r * r) +
        0.587 * (g * g) +
        0.114 * (b * b));
    // Using the HSP value, to determine if we need to inverse the color...
    // Normally 128 is used to determine if a color is light or dark, we adjusted that to our own needs
    return hsp < 213;
};
/**
 *
 * @param {Object} props
 * @param {string} props.className
 * @param {function} props.onChange
 * @param {string} props.background - background corresponds to the css background property value for color or svg
 * @param {string} props.value
 * @param {string} props.label
 * @param {string} props.size
 * @param {boolean} props.isSelected
 * @param {string} props.productCode
 * @param {string} props.attributeCode
 * @param {boolean} props.isOutOfStock
 * @returns {import('react').ReactNode}
 */
const Swatch = ({ className, onChange, background, value, label, size = 'medium', isSelected = false, attributeCode, isOutOfStock }) => {
    const isSmall = size === 'small';
    const isMedium = size === 'medium';
    const isInvertedColor = inverseCheckIconColor(background);
    const classes = (0, classnames_1.default)(Swatch_module_scss_1.default.swatchContainer, {
        [Swatch_module_scss_1.default['swatchContainer-selected']]: isSelected,
        [Swatch_module_scss_1.default['swatchContainer-small']]: isSmall,
        [Swatch_module_scss_1.default['swatchContainer-medium']]: isMedium,
    }, className);
    const iconClasses = (0, classnames_1.default)(Swatch_module_scss_1.default.icon, {
        [Swatch_module_scss_1.default['icon-selected']]: isSelected,
        [Swatch_module_scss_1.default['icon-inverse']]: isInvertedColor,
    });
    const inlineStyles = {
        background,
    };
    const oosColor = isInvertedColor ? 'dark' : 'light';
    const oosSelected = isSelected ? 'selected' : 'default';
    const oosSpriteSvg = `u-swatch-out-of-stock-${oosSelected}-${oosColor}.svg`;
    return ((0, jsx_runtime_1.jsxs)("button", { "data-selector": `${attributeCode}-swatch-${value}`, className: classes, onClick: () => onChange(value), role: 'radio', type: 'button', "aria-checked": isSelected, "aria-label": `${label} swatch`, children: [isOutOfStock && ((0, jsx_runtime_1.jsx)("img", { alt: "Out Of Stock Swatch", src: `/static/assets/icons/${oosSpriteSvg}`, className: Swatch_module_scss_1.default.outOfStockSlash })), (0, jsx_runtime_1.jsx)("div", { className: Swatch_module_scss_1.default.swatch, style: inlineStyles, children: !isOutOfStock && ((0, jsx_runtime_1.jsx)(pattern_library_components_icon_1.Icon, { className: iconClasses, name: "check", alt: "Check Mark", titleId: "checkMark", description: "Check Mark" })) })] }));
};
Swatch.propTypes = {
    onChange: prop_types_1.default.func.isRequired,
    value: prop_types_1.default.string.isRequired,
    label: prop_types_1.default.string.isRequired,
    background: prop_types_1.default.string.isRequired,
    className: prop_types_1.default.string,
    size: prop_types_1.default.oneOf(['small', 'medium']),
    isSelected: prop_types_1.default.bool,
    productCode: prop_types_1.default.string,
    attributeCode: prop_types_1.default.string,
    isOutOfStock: prop_types_1.default.bool
};
exports.default = Swatch;
//# sourceMappingURL=Swatch.js.map